// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.peptalk-widget-container .peptalk-home{display:grid;grid-template-rows:1fr 1fr;gap:var(--peptalk-spacing-sm)}`, "",{"version":3,"sources":["webpack://./src/components/Home/styles.scss"],"names":[],"mappings":"AAAA,wCACE,YAAA,CACA,0BAAA,CACA,6BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
